import React, {forwardRef, type InputHTMLAttributes} from "react";
import cn from "classnames";

import * as styles from "./Input.module.css";

export interface IProps extends Partial<Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">> {
    error?: boolean;
    onChange?: (value: string | number) => void;
}

export const Input = forwardRef<HTMLInputElement, IProps>((props, inputRef) => {
    const {className, error, onChange, type = "text", value, ...inputProps} = props;

    return (
        <div className={cn(className, styles.inputContainer, error && styles.inputContainerError)}>
            <input
                ref={inputRef}
                className={styles.input}
                onChange={(e) => onChange?.(type === "number" && !Number.isNaN(e.target.valueAsNumber) ? e.target.valueAsNumber : e.target.value)}
                type={type}
                value={value === null ? "" : value}
                {...inputProps}
            />
        </div>
    );
});
import React, {forwardRef, type InputHTMLAttributes} from "react";
import cn from "classnames";

import * as styles from "./Input.module.css";

export interface IProps extends Partial<Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">> {
    error?: boolean;
    onChange?: (value: string | number) => void;
}

export const Input = forwardRef<HTMLInputElement, IProps>((props, inputRef) => {
    const {className, error, onChange, type = "text", value, ...inputProps} = props;

    return (
        <div className={cn(className, styles.inputContainer, error && styles.inputContainerError)}>
            <input
                ref={inputRef}
                className={styles.input}
                onChange={(e) => onChange?.(type === "number" && !Number.isNaN(e.target.valueAsNumber) ? e.target.valueAsNumber : e.target.value)}
                type={type}
                value={value === null ? "" : value}
                {...inputProps}
            />
        </div>
    );
});
